import type { CompareSlug } from "@/config/compare";

/**
 * Compare pages the `/compare` hub features above its alphabetical groups.
 *
 * Code-owned, like a compare page's `kind`: the featured set is a ranking
 * decision, so it never lives in translatable frontmatter (`yarn translate`
 * would localize it) and the hub never hardcodes a slug. Order is display
 * order. Typed as {@link CompareSlug} so a slug with no compare page is a
 * compile error; the reasons stay comments so they never ship to the client.
 */
export const COMPARE_FEATURED_SLUGS = [
  // QuickBooks is the comparison in a buyer's head; most paying
  // hosted-Beancount professionals advertise QuickBooks services.
  "beancount-vs-quickbooks",
  // The broad "leave QuickBooks" intent; hands off to the head-to-head page
  // and the migration guide.
  "quickbooks-alternatives",
  // Xero is the second small-business incumbent readers switch from.
  "xero-alternatives",
  // Wave is the free small-business ledger readers most often weigh next.
  "wave-alternatives",
] as const satisfies readonly CompareSlug[];

/**
 * The featured subset of `pages`, in config order. Slugs with no matching
 * page are skipped rather than rendered empty.
 */
export function selectFeaturedComparePages<T extends { slug: string }>(
  pages: readonly T[],
): T[] {
  const bySlug = new Map(pages.map((page) => [page.slug, page]));
  return COMPARE_FEATURED_SLUGS.flatMap((slug) => {
    const page = bySlug.get(slug);
    return page ? [page] : [];
  });
}
